<template lang="pug">
  #page.login
    b-container
      b-row
        .col-4
            b-card.mt-5.py-4(title="Sistema web")
              h1 Bienvenido
              b-form(@submit='onSubmit' @reset='onReset')
                b-form-group#input-firstName-group(label-for='input-firstName')
                  b-form-input#input-firstName(v-model='form.userName' required='' size="lg" placeholder='Usuario')
                b-form-group#input-lastName-group(label-for='input-lastName')
                  b-form-input#input-lastName(v-model='form.password' type="password" required='' size="lg" placeholder='Contraseña')
                b-form-group#input-group
                  b-button(type='submit' variant='secondary' size="lg" block) Ingresar
                    b-spinner.ml-2(v-if="loading" label="Loading..." small)
                //b-form-group#input-group
                  b-button(type='reset' variant='primary' block) Acceso administrador
        .col-8
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["user"]),
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.signIn();
    },
    onReset(evt) {
      evt.preventDefault();
      console.log(this.$store);
      /*
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });*/
    },
    async signIn() {
      try {
        this.loading = true;
        await this.$store.dispatch("signIn", {
          vm: this,
          userName: this.form.userName,
          password: this.form.password,
        });

        // this.$router.push("/");
        this.$router.push({
          path: this.$cookies.get("role") == "accountant" ? "/search" : "/",
        });
      } catch (error) {
        console.log(error);
      } finally {
        console.log("fin Login");
        this.loading = false;
      }
      /*if (data.token) {
        this.$cookies.set("token", data.token);
        this.$cookies.set("id", data.user.id);
        this.$cookies.set("userName", data.user.userName);
        // this.$router.push("/");
        this.$router.go("/");
      } else {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Incorrect username or password!",
        });
      }*/
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  background-image: linear-gradient(45deg, #0066, #e136),
    url("~@/assets/plane-back.jpg");
  background-position: 50% 50%;
  flex: auto;
  background-size: cover;
  color: white;
}

.login .card {
  backdrop-filter: blur(2em);
  background-color: rgba(255, 255, 255, 0.25);
}

/*.border-transparent {
  border-color: transparent;
}*/
</style>
